/* eslint-disable @typescript-eslint/no-explicit-any */
import Contentstack from 'contentstack';

import {
  API_KEY,
  BRANCH,
  DELIVERY_TOKEN,
  ENVIRONMENT,
  LIVE_PREVIEW_ENABLED,
  PREVIEW_API_HOST,
  PREVIEW_TOKEN,
  REGION,
} from './settings';

export type PreviewStack = any;

const createPreviewStack = (): PreviewStack | undefined => {
  if (typeof window === 'undefined' || !LIVE_PREVIEW_ENABLED) return undefined;

  return Contentstack.Stack({
    api_key: API_KEY,
    delivery_token: DELIVERY_TOKEN,
    environment: ENVIRONMENT,
    region: REGION as Contentstack.Region,
    branch: BRANCH,
    live_preview: {
      enable: true,
      host: PREVIEW_API_HOST,
      preview_token: PREVIEW_TOKEN,
    },
  } as Contentstack.Config);
};

export const previewStack = createPreviewStack();

export const hasPreviewHash = (): boolean => {
  const hash = previewStack?.live_preview?.live_preview;

  return !!hash && hash !== 'init';
};

const HASH_POLL_MS = 100;
const HASH_WAIT_MS = 5000;

let pendingHash: Promise<boolean> | undefined;

export const waitForPreviewHash = (): Promise<boolean> => {
  if (hasPreviewHash()) return Promise.resolve(true);

  pendingHash ??= pollForPreviewHash();

  return pendingHash;
};

const pollForPreviewHash = (): Promise<boolean> =>
  new Promise((resolve) => {
    const startedAt = Date.now();

    const pollId = window.setInterval(() => {
      if (hasPreviewHash()) {
        window.clearInterval(pollId);
        resolve(true);

        return;
      }

      if (Date.now() - startedAt > HASH_WAIT_MS) {
        window.clearInterval(pollId);
        console.warn(
          '[live-preview] the editor did not send a preview hash - the entry may be read from the published CDN'
        );
        resolve(false);
      }
    }, HASH_POLL_MS);
  });
